export default {
  ar() {
    return {
      codeHeader: 'إليك كود هدية بقيمة 50 دولارًا لمتجر F1:',
      enterCode: 'أدخل رمز الهدية عند إستكمال طلب الشراء ضمن قسم "الدفع والخصومات"',
      f1StoreLink: 'إذهب إلي <a href={link} target="_blank" rel="noopener noreferrer">متجر F1</a>',
      instructionsHeader: 'لاستخدام هديتك، يرجى اتباع التعليمات التالية:',
      saveOffPurchase: 'وفر 50 دولارًا من عملية الشراء!',
      selectGift: 'حدد فريقك المفضل أو البائئعين التابعين لسائقك المفضل، أو اختر من بين مجموعة من الهدايا والإكسسوارات التي تحمل شعار F1',
      yourGiftCode: 'هديتك في {eventName}'
    }
  },
  de() {
    return {
      codeHeader: 'Hier ist Ihr USD 50 Code für den F1 Store:',
      enterCode: 'Geben Sie den Code bei der Kasse im Bereich \'Zahlungen & Ermäßigungen\' ein',
      f1StoreLink: 'Besuchen Sie den <a href={link} target="_blank" rel="noopener noreferrer">F1 Store</a>',
      instructionsHeader: 'Bitte folgen Sie diesen Anweisungen, um Ihr Geschenk einzulösen:',
      saveOffPurchase: 'Sparen Sie USD 50 auf Ihren Einkauf!',
      selectGift: 'Wählen Sie Merchandising-Artikel von Ihrem Lieblingsteam oder -fahrer oder suchen Sie sich aus einer Reihe von F1 Geschenken und Accessoires Ihren Favoriten aus.',
      yourGiftCode: 'Ihr {eventName} Geschenk'
    }
  },
  en() {
    return {
      codeHeader: 'Here is your $50 USD code for the F1 Store:',
      enterCode: 'Enter the gift code at checkout under the \'Payment & Discounts\' section',
      f1StoreLink: 'Go to the <a href={link} target="_blank" rel="noopener noreferrer">F1 Store</a>',
      instructionsHeader: 'To redeem your gift, please follow these instructions:',
      saveOffPurchase: 'Save $50 USD off your purchase!',
      selectGift: 'Select your favorite team or driver merchandise, or choose from a range of F1 themed gifts and accessories',
      yourGiftCode: 'Your {eventName} Gift'
    }
  },
  enGB() {
    return {
      codeHeader: 'Here is your $50 USD code for the F1 Store:',
      enterCode: 'Enter the gift code at checkout under the \'Payment & Discounts\' section',
      f1StoreLink: 'Go to the <a href={link} target="_blank" rel="noopener noreferrer">F1 Store</a>',
      instructionsHeader: 'To redeem your gift, please follow these instructions:',
      saveOffPurchase: 'Save $50 USD off your purchase!',
      selectGift: 'Select your favorite team or driver merchandise, or choose from a range of F1 themed gifts and accessories',
      yourGiftCode: 'Your {eventName} Gift'
    }
  },
  esMX() {
    return {
      codeHeader: 'Aquí está su código de regalo de $50 USD para la Tienda F1:',
      enterCode: 'Enter the gift code at checkout under the \'Payment & Discounts\' section',
      f1StoreLink: 'Ir a la <a href={link} target="_blank" rel="noopener noreferrer">Tienda F1</a>',
      instructionsHeader: 'Para obtener su regalo, favor de seguir estas instrucciones:',
      saveOffPurchase: '¡Ahorre $50 USD en su compra!',
      selectGift: 'Select your favorite team or driver merchandise, or choose from a range of F1 themed gifts and accessories',
      yourGiftCode: 'Su Regalo {eventName}'
    }
  },
  fr() {
    return {
      codeHeader: 'Voici votre code de réduction de 50 USD pour la boutique de F1 :',
      enterCode: 'Saisissez votre code promo à la finalisation de l\'achat en dessous de la section "Paiement et Remises".',
      f1StoreLink: 'Allez sur <a href={link} target="_blank" rel="noopener noreferrer">la boutique F1</a>.',
      instructionsHeader: 'Pour échanger votre code de réduction, veuillez suivre les instructions suivantes :',
      saveOffPurchase: 'Économisez 50 USD sur votre achat !',
      selectGift: 'Choisissez un article de votre écurie ou votre pilote favori(te), ou choisissez parmi les cadeaux et les accessoires au thème de la F1.',
      yourGiftCode: 'Votre cadeau pour le {eventName}'
    }
  },
  it() {
    return {
      codeHeader: 'Ecco il tuo codice sconto da 50$ valido per l\'F1 Store:',
      enterCode: 'Inserisci il codice omaggio alla cassa nella sezione "Pagamento e sconti"',
      f1StoreLink: 'Vai al <a href={link} target="_blank" rel="noopener noreferrer">F1 Store</a>',
      instructionsHeader: 'Se desideri riscattare il tuo buono, ti invitiamo a seguire queste istruzioni:',
      saveOffPurchase: 'Risparmia 50$ sul tuo acquisto!',
      selectGift: 'Scegli il merchandising della tua scuderia o del tuo pilota preferito oppure un qualsiasi altro gadget tra la vasta gamma di regali e accessori legati alla F1',
      yourGiftCode: 'Il tuo omaggio per il {eventName}'
    }
  },
  ja() {
    return {
      codeHeader: 'F1ストア用の50米ドルコードを以下に表示します。',
      enterCode: 'お支払い & 割引の下のチェックアウトでギフトコードをご確認ください。',
      f1StoreLink: '<a href={link} target="_blank" rel="noopener noreferrer">F1 ストア</a>へ行く',
      instructionsHeader: 'ギフトの引き換えには、以下の指示に従がってください：',
      saveOffPurchase: 'お客様のご購入から$50 USD割引！',
      selectGift: 'お気に入りのチームまたはドライバーの商品を選ぶか、F1をテーマにしたギフトやアクセサリをお選びください',
      yourGiftCode: 'お客様の{eventName} ギフト'
    }
  },
  pl() {
    return {
      codeHeader: 'kod na rabat w wysokości 50 USD na zakupy w sklepie F1:',
      enterCode: 'po przejściu do kasy wpisz kod rabatowy w pozycji „płatność i rabaty”',
      f1StoreLink: 'przejdź do <a href={link} target="_blank" rel="noopener noreferrer">sklepu F1</a>',
      instructionsHeader: 'Co zrobić, żeby skorzystać z rabatu:',
      saveOffPurchase: 'Zaoszczędź 50 USD podczas najbliższych zakupów.',
      selectGift: 'wybierz produkty swojego ulubionego zespołu lub kierowcy bądź wybierz pozycje spośród upominków i akcesoriów F1',
      yourGiftCode: 'YTwój upominek na {eventName}'
    }
  },
  zhCN() {
    return {
      codeHeader: '这是您的F1商店50美元礼品代码：',
      enterCode: '结账时在‘付款和折扣’下面输入礼品代码',
      f1StoreLink: '跳转至<a href={link} target="_blank" rel="noopener noreferrer">F1商店</a>',
      instructionsHeader: '请按照以下说明兑换礼品：',
      saveOffPurchase: '购买可省50美元！',
      selectGift: '选择您喜欢的车队或车手商品，或从一系列F1主题礼品和配件中选择您中意的',
      yourGiftCode: '您的{eventName}礼品'
    }
  }
}
